import { Injectable, EventEmitter } from '@angular/core';
// import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
//import { Observable } from 'rxjs';
import { UserManager, User, WebStorageStateStore } from 'oidc-client';
import { Store } from '@ngrx/store';
import * as fromRoot from '../state/reducers/index';
import { Logger } from './logger';
import { ViewConstants } from '../../constants';

import { AppState } from '../../state/app.state';
// import { environment } from '../../';

import {
  EnvironmentConfiguration, environments
} from  '../../environment/services/environment.configuration';
const environment = new EnvironmentConfiguration(environments); 
// https://login.microsoftonline.com/lexustmsdev.onmicrosoft.com/oauth2/v2.0/authorize?p
// =B2C_1A_RT_Toyota_FR_QA_SignInPolicy&client_Id=c7848929-67f9-4327-b1bd-a744c4acea03
// &nonce=defaultNonce&redirect_uri=https%3A%2F%2Fui.rti.dev.toyota.com%2F
// &scope=openid&response_type=id_token&prompt=login&ui_locales=en

const settings: any = {
  authority: environment.AUTHORITY,
  // authority: 'https://login.microsoftonline.com/lexustmsdev.onmicrosoft.com/' +
  // 'oauth2/v2.0/authorize?p=B2C_1A_RTPOCsignin&prompt=login',
  client_id: environment.CLIENT_ID,
  // redirect_uri: 'https://ui.rti.dev.toyota.com/',
  redirect_uri: environment.SILENT_REDIRECT_URL,
  post_logout_redirect_uri: environment.POST_LOGOUT_REDIRECT_URL,
  // response_type: ViewConstants.ID_TOKEN_HTTP_CLIENT,
  response_type: ViewConstants.ACCESS_TOKEN_HTTP_CLIENT,
  scope: 'openid',
  // prompt: 'login',
  // signingKeys: [
  //   {
  //     kid: 'key0',
  //     use: 'sig',
  //     kty: 'RSA',
  //     e: 'AQAB',
  //     n: SIGN_IN_KEY_N
  //   }
  // ]
  // ,

  // metadata: {
  //   authorization_endpoint: 'https://login.microsoftonline.com/lexustmsdev.onmicrosoft.com/' +
  //   'oauth2/v2.0/authorize?p=B2C_1A_RT_Toyota_FR_QA_SignInPolicy',
  //   issuer: 'https://login.microsoftonline.com/83c5248c-ca1a-49b1-9465-0099705092b7/v2.0/',
  //   userinfo_endpoint: '',
  //   jwks_uri: 'https://login.microsoftonline.com/lexustmsdev.onmicrosoft.com/discovery/' +
  //   'v2.0/keys?p=B2C_1A_RT_Toyota_FR_QA_SignInPolicy',
  // },
  metadata: {
    authorization_endpoint: environment.AUTHORIZATION_ENDPOINT,
    issuer: environment.ISSUER,
    userinfo_endpoint: '',
    jwks_uri: environment.JWTURI,
  },

  // silent_redirect_uri: 'https://rti.dev.toyota.com/rti-dealer-ui/',
  silent_redirect_uri: environment.SILENT_REDIRECT_URL,
  silentRequestTimeout: 10000,
  filterProtocolClaims: true,
  loadUserInfo: false,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  // For Silent Renew
  accessTokenExpiringNotificationTime: 60,
  includeIdTokenInSilentRenew: true,
  automaticSilentRenew: true,

  // For Signin Popup
  popup_redirect_uri: environment.SILENT_REDIRECT_URL,
  // Given maximum values for left and top
  popupWindowFeatures: 'location=no,toolbar=no,menubar=no,titlebar=no,resizable=no,status=no,scrollbars=no,width=100,height=100,left=' + screen.width + ',top=' + screen.height,
  popupWindowTarget: '_blank'
};

@Injectable(
  { providedIn: 'root' }
)
export class AuthServiceTESS {
  mgr: UserManager = new UserManager(settings);
  // Event emit function for user loaded
  userLoadededEvent: EventEmitter<User> = new EventEmitter<User>();
  // to store current user details
  currentUser: User;
  // flag to checked logged in
  loggedIn: boolean = false;
  // to store authheaders
  authHeaders: Headers;
  // to store route url
  originalRouteURL: string;
  // baseURL: string = DEV_AUTH_BASE_URL;
  baseURL: string = this.environment.AUTH_BASE_URL;
  /**
   * constructor method to create new instances
   */
  constructor(private http: HttpClient,
    private store: Store<AppState>,
    private logger: Logger,private environment : EnvironmentConfiguration) {

    logger.log('inside auth service');
    //   this.mgr.getUser()
    //   .then((user) => {
    //     if (user) {
    //       this.loggedIn = true;
    //       this.currentUser = user;
    //       this.userLoadededEvent.emit(user);
    //     }
    //     else {
    //       this.loggedIn = false;
    //     }
    //   })
    //   .catch((err) => {
    //     this.loggedIn = false;
    //   });
    // this.mgr.events.addUserUnloaded((e) => {
    //   // if (!environment.production) {
    //   //   logger.log('user unloaded');
    //   // }
    //   this.loggedIn = false;
    // });
  }
  isUserAuthorized() {
    if (this.currentUser &&
      (this.currentUser.profile.roles
        .indexOf(ViewConstants.DD_RTI_MST_CONSOLE) > -1)) {
      return true;
    } else {
      return false;
    }
  }
  getUser() {
    let that = this;
    return this.mgr.getUser().then((user) => {
      // this.store.dispatch(new authDataActions.SetLoggedInUserDataAction(user));
      // that.logger.log('user data received', user);
      this.userLoadededEvent.emit(user);
      return user;

    }).catch(function (err) {
      that.logger.log(err);
    });
  }

  removeUser() {
    let that = this;
    this.mgr.removeUser().then(() => {
      this.userLoadededEvent.emit(null);
      that.logger.log('user removed');
    }).catch(function (err) {
      that.logger.log(err);
    });
  }

  startSigninMainWindow(url: string) {
    // TODO : Not working
    // this.store.dispatch(new authDataActions.SetOriginalURLAccessedAction(url));
    let that = this;
    this.mgr.signinRedirect({ data: 'some data' }).then(function () {
      // this.mgr.signinPopup({ data: 'some data' }).then(function () {
      // this.mgr.signinSilent({ data: 'some data' }).then(function () {
      that.logger.log('signinRedirect done');
    }).catch(function (err) {
      that.logger.log(err);
    });
  }

  endSigninMainWindow(url?: string) {
    let that = this;
    return this.mgr.signinRedirectCallback(url).then(function (user) {
      // return this.mgr.signinPopupCallback(url).then(function (user) {
      // return this.mgr.signinSilentCallback(url).then(function (user) {
      // that.logger.log('signed in', user);
    }).catch(function (err) {
      that.logger.log(err);
    });
  }

  startSigninPopup() {
    // TODO : Not working
    // this.store.dispatch(new authDataActions.SetOriginalURLAccessedAction(url));
    let that = this;
    return this.mgr.signinPopup({ data: 'some data' }).then(function (User) {
      // this.mgr.signinPopup({ data: 'some data' }).then(function () {
      // this.mgr.signinSilent({ data: 'some data' }).then(function () {
    }).catch(function (err) {
      that.logger.log(err);
    });
  }

  endSigninPopup() {
    // TODO : Not working
    // this.store.dispatch(new authDataActions.SetOriginalURLAccessedAction(url));
    let that = this;
    this.mgr.signinPopupCallback().then(function (dt) {
    }).catch(function (err) {
      that.logger.log(err);
    });
  }

  startSignoutMainWindow() {
    let that = this;
    this.mgr.signoutRedirect().then(function (resp) {
      that.logger.log('signed out', resp);
      setTimeout(() => {
        that.logger.log('testing to see if fired...');

      }, 5000);
    }).catch(function (err) {
      that.logger.log(err);
    });
  };

  endSignoutMainWindow() {
    let that = this;
    this.mgr.signoutRedirectCallback().then(function (resp) {
      that.logger.log('signed out', resp);
    }).catch(function (err) {
      that.logger.log(err);
    });
  };
  // /**
  //  * Example of how you can make auth request using angulars http methods.
  //  * @param options if options are not supplied the default content type is application/json
  //  */
  // AuthGet(url: string, options?: RequestOptions): Observable<Response> {

  //   if (options) {
  //     options = this._setRequestOptions(options);
  //   } else {
  //     options = this._setRequestOptions();
  //   }
  //   return this.http.get(url, options);
  // }
  // /**
  //  * @param options if options are not supplied the default content type is application/json
  //  */
  // AuthPut(url: string, data: any, options?: RequestOptions): Observable<Response> {

  //   let body = JSON.stringify(data);

  //   if (options) {
  //     options = this._setRequestOptions(options);
  //   } else {
  //     options = this._setRequestOptions();
  //   }
  //   return this.http.put(url, body, options);
  // }
  // /**
  //  * @param options if options are not supplied the default content type is application/json
  //  */
  // AuthDelete(url: string, options?: RequestOptions): Observable<Response> {

  //   if (options) {
  //     options = this._setRequestOptions(options);
  //   } else {
  //     options = this._setRequestOptions();
  //   }
  //   return this.http.delete(url, options);
  // }
  // /**
  //  * @param options if options are not supplied the default content type is application/json
  //  */
  // AuthPost(url: string, data: any, options?: RequestOptions): Observable<Response> {

  //   let body = JSON.stringify(data);

  //   if (options) {
  //     options = this._setRequestOptions(options);
  //   } else {
  //     options = this._setRequestOptions();
  //   }
  //   return this.http.post(url, body, options);
  // }


  // // private _setAuthHeaders(user: any) {
  // //   this.authHeaders = new Headers();
  // //   this.authHeaders.append('Authorization', user.token_type + ' ' + user.access_token);
  // //   this.authHeaders.append('Content-Type', 'application/json');
  // // }
  // _setRequestOptions(options?: RequestOptions) {

  //   if (options) {
  //     options.headers.append(this.authHeaders.keys[0], this.authHeaders.values[0]);
  //   } else {
  //     options = new RequestOptions({ headers: this.authHeaders, body: '' });
  //   }

  //   return options;
  // }

}


